import StandardLoader from './StandardLoader'
export default StandardLoader
